"use client";
import Link from "next/link";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { FiGithub } from "react-icons/fi";
import { MdEmail } from "react-icons/md";
import { Meteors } from "@/components/ui/meteors";
import { HoverBorderGradient } from "@/components/ui/hover-border-gradient";
import { personalData } from "@/utils/data/personal-data";
import SectionHeading from "../../section-heading";

function ContactSection() {
  return (
    <section id="contact" className="relative py-24 px-4">
      <SectionHeading
        eyebrow="[Contact]"
        title="Let's build"
        highlight="together"
        description="Open to frontend and full-stack roles, freelance product work, and collaborations."
      />

      <div className="relative max-w-2xl mx-auto overflow-hidden rounded-2xl border border-white/10 bg-neutral-950 p-8 sm:p-12">
        <Meteors number={18} />
        <div className="relative z-10 flex flex-col items-center gap-5 text-center">
          <div className="bg-violet-500/15 p-4 rounded-full border border-violet-500/30">
            <MdEmail className="text-4xl text-violet-300" />
          </div>
          <h3 className="text-2xl font-semibold">Start a conversation</h3>
          <a
            href={`mailto:${personalData.email}`}
            className="text-cyan-300 hover:text-cyan-200 transition-colors"
          >
            {personalData.email}
          </a>
          <p className="text-neutral-400">{personalData.phone} · {personalData.address}</p>
          <p className="text-neutral-300 max-w-md">
            I am always open to discussing new products, dashboards, and frontend systems.
          </p>
          <HoverBorderGradient
            as="a"
            href={`mailto:${personalData.email}`}
            className="bg-neutral-950 text-white px-6 py-2"
          >
            Email me
          </HoverBorderGradient>
        </div>
      </div>

      <div className="flex items-center justify-center gap-4 mt-10">
        <Link
          href={personalData.linkedIn}
          target="_blank"
          className="bg-white/5 p-4 rounded-full border border-white/10 hover:border-violet-400/50 hover:bg-violet-500/20 transition-all"
        >
          <FaLinkedinIn className="text-xl" />
        </Link>
        <Link
          href={personalData.github}
          target="_blank"
          className="bg-white/5 p-4 rounded-full border border-white/10 hover:border-violet-400/50 hover:bg-violet-500/20 transition-all"
        >
          <FiGithub className="text-xl" />
        </Link>
        <Link
          href={personalData.whatsapp}
          target="_blank"
          className="bg-white/5 p-4 rounded-full border border-white/10 hover:border-violet-400/50 hover:bg-violet-500/20 transition-all"
        >
          <FaWhatsapp className="text-xl" />
        </Link>
      </div>
    </section>
  );
}

export default ContactSection;
